export function getCurrentCmsPageId() {
    const id = document.documentElement.dataset?.currentPageId;
    return Number.parseInt(id);
}